import reduce from 'lodash/reduce';

import { SCHEMAS } from 'src/app/popsicle/schemas';
import { LOCATIONS, MAP_DMA_METRO_CODE_TO_CAPSULE_LOCATION } from 'src/consts';

const _convertedlocation = detectedUserLocation => {
  return MAP_DMA_METRO_CODE_TO_CAPSULE_LOCATION[detectedUserLocation]
    ? MAP_DMA_METRO_CODE_TO_CAPSULE_LOCATION[detectedUserLocation]
    : LOCATIONS.DEFAULT;
};

export function getInitialResourcesState() {
  return reduce(
    Object.keys({ ...SCHEMAS, CartItem: {}, GeoDeliveryTier: {}, NewInsurance: {} }),
    (state, type) => {
      state[type] = {};
      return state;
    },
    {}
  );
}

export function getInitialLocationState() {
  const ele: any = document.head.querySelector('[name~=geolocation][content]');
  const detectedUserLocation = ele ? ele.content : '';

  return {
    preferredLocation: _convertedlocation(detectedUserLocation),
    showDebug: false,
  };
}

export default function getInitialState() {
  return {
    resources: getInitialResourcesState(),
    location: getInitialLocationState(),
  };
}
